import { fabric } from '../common/fabric';
import { userinfo } from '../common/userinfo';
import { ui } from '../common/ui';
import { parts } from '../common/parts';
import { drawing } from '../common/drawing';
import { roleIdToRoleName } from '../../utilities/roleUtility';
import { getNextDay } from '../common/works';
import { printPdf } from './print';
import { split } from './split';
import { places } from './places';
import { client } from './client_v2';
import SessionStorageService from '../../services/utilities/SessionStorageService';
import $ from 'jquery';

export const layoutInit = async function(currentPlaceId) {
  // ユーザ情報初期化
  await userinfo.init({
    field_id: sessionStorage.getItem('field_id'),
    field_name: null,
    user_id: localStorage.getItem('user_id'),
    user_name: null,
    user_type: roleIdToRoleName(localStorage.getItem('role_id')),
    company_id: null,
  });

  // パラメータとして明日以降の稼働日直近日付を受け取る
  const currentDate = await getNextDay(userinfo.getFieldId());

  // UI要素を初期化
  $('.layout-header__title').css({
    textIndent: '16px',
  });
  ui.init(currentDate);

  // 場所情報を初期化
  places.init(currentPlaceId);

  // 印刷設定を初期化
  printPdf.init();

  // 部品設定を初期化
  parts.init();

  // Canvasを初期設定
  drawing.setCanvas('canvas');

  // 分割画面を初期化
  split.init('canvas-split');

  // サーバーSocket通信の初期化
  await client.init();

  // drawingオブジェクトに client / places を指定する
  drawing.client = client;
  drawing.places = places;
  drawing.split = split;

  // ツールバーボタン初期化
  ui.toolboxSelect('tool-pan');

  // 外部ユーザーの場合は、ツールボタン群の操作をできないように非表示にする
  if (SessionStorageService.isExtraProxiLogin()) {
    ui.toolboxHide();
  }

  // fabric.eg を初期化
  //  drawingの設定
  //  利用者情報の設定
  fabric.eg.init({
    drawing,
    userId: userinfo.getUserId(),
    userName: userinfo.getUserName(),
    companyName: userinfo.getUserCompanyName(),
  });

  $('.rail__main .main .main__header').show();
};



// WEBPACK FOOTER //
// ./src/canvas/constructionPlacement/init.js